import React, { Component } from 'react'
import interact from 'interactjs'

import Item from './Item'
import { isTouchDevice } from '../utils'

class Layout extends Component {
    state = {
        open: false,
        translateX: 0,
        n: 0,
        openHeight: window.innerHeight,
        closing: false
    }

    layout = React.createRef()
    holes = []

    componentDidMount() {
        const { resize } = this.props
        window.addEventListener('resize', this.onResize)
        window.dragMoveListener = this.moveListener
        this.test = interact(this.layout.current)
            .draggable({
                enabled: false,
                inertia: {
                    resistance: 10,
                    minSpeed: 20,
                    endSpeed: 140,
                },
                restrict: {
                    elementRect: { left: 0, right: 0, top: 1, bottom: 1 }
                },
                axis: 'x',
                onstart: this.start,
                onmove: this.moveListener,
                onend: this.upEvent
            })
            .on('tap', ({ clientX }) => {
                const { open } = this.state
                if (!open) {
                    return
                }
                if (window.innerWidth / 2 > clientX) {
                    this.previous()
                } else {
                    this.next()
                }
            })
        resize()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize)
    }

    onOpen = (n) => {
        const { open } = this.state
        if (!open) {
            const touch = isTouchDevice()
            this.test.options.drag.enabled = !touch
            this.props.saveScroll()
            document.querySelector('html').style.overflow = 'hidden'
            const tr = n * (window.innerWidth + 100)
            window.addEventListener('keydown', this.keyHandler)
            this.setState({ open: true, translateX: tr, n, openHeight: window.innerHeight })
        }
    }

    keyHandler = (evt) => {
        const { keyCode } = evt
        if (keyCode === 37) {
            this.previous()
        } else if (keyCode === 39) {
            this.next()
        } else if (keyCode === 27) {
            this.onClose()
        }
    }

    start = () => {
        const { open } = this.state
        if (!open) {
            return
        }
        this.layout.current.style.transition = null
        clearTimeout(this.timer)
    }

    moveListener = (evt) => {
        const { open } = this.state
        if (!open) {
            return
        }
        const { translateX } = this.state
        this.setState({ translateX: translateX - evt.dx })
    }

    onResize = () => {
        const { n, open } = this.state
        if (n && open) {
            this.setState({ translateX: (window.innerWidth + 100) * n, openHeight: window.innerHeight })
        }
    }

    upEvent = (evt) => {
        const { open } = this.state
        if (!open) {
            return
        }
        const { translateX, n } = this.state
        const { items, holes } = this.props
        let t = Math.round(translateX / (window.innerWidth + 100))
        if (n === t) {
            t += t * (window.innerWidth + 100) < translateX ? 1 : -1
        }
        const length = this.holes.length > holes.length ? holes.length : this.holes.length
        if (t > items.length + length - 1) {
            t = items.length + length - 1
        } else if (t < 0) {
            t = 0
        }
        const obj = t * (window.innerWidth + 100)
        const duration = 450
        this.transition(duration, translateX, obj, t)
    }

    next = () => {
        const { n, translateX } = this.state
        const { items, holes } = this.props
        const length = this.holes.length > holes.length ? holes.length : this.holes.length
        if (n + 1 > items.length + length - 1) {
            return
        }
        clearTimeout(this.timer)
        const to = (n + 1) * (window.innerWidth + 100)
        this.setState({ n: n + 1 })
        this.transition(500, translateX, to, n + 1)
    }

    previous = () => {
        const { n, translateX } = this.state
        if (n - 1 < 0) {
            return
        }
        clearTimeout(this.timer)
        const to = (n - 1) * (window.innerWidth + 100)
        this.setState({ n: n - 1 })
        this.transition(500, translateX, to, n - 1)
    }

    transition = (duration, from, to, n) => {
        this.layout.current.style.transition = 'transform .35s'
        this.setState({ translateX: to, n })
        this.timer = setTimeout(() => {
            this.layout.current.style.transition = null
        }, 350)
    }

    onClose = () => {
        const { setScroll } = this.props
        this.test.options.drag.enabled = false
        this.setState({ open: false, closing: true }, () => {
            setScroll()
            setTimeout(() => {
                this.setState({ closing: false })
            }, 700)
        })
        window.removeEventListener('keydown', this.keyHandler)
        document.querySelector('html').style.overflow = null
    }

    render() {
        const { open, translateX, openHeight, closing } = this.state
        const activeN = this.state.n
        const { startX, startY, items, maxWidth, normalSize, biggerSize, spacing, numberOfCol, holes, tagSelectorHeight } = this.props
        const classN = ["layout"]
        let width
        let height
        let item
        if (!open) {
            if (closing) {
                classN.push("closing")
            }
            width = maxWidth
            let row = 0
            let column = 0
            let rowX = spacing / 2
            const grid = {}
            this.holes = []
            let n = -1
            item = items.map(item => {
                // Check for new line
                if (column === numberOfCol || (item.isBigger && column + 1 >= numberOfCol) || (item.isRect && column + 2 >= numberOfCol)) {
                    while (column !== numberOfCol) {
                        if (!grid[`${row};${column}`]) {
                            this.holes.push({
                                key: (column + 10) * (row + 20),
                                x: rowX,
                                y: tagSelectorHeight + row * (normalSize + spacing)
                            })
                        }
                        column += 1
                        rowX += normalSize + spacing
                    }
                    rowX = spacing / 2
                    row += 1
                    column = 0
                }
                while (grid[`${row};${column}`] || ((item.isBigger || item.isRect) && grid[`${row};${column + 1}`]) || (item.isRect && grid[`${row};${column + 2}`])) {
                    if (!grid[`${row};${column}`]) {
                      this.holes.push({
                        key: (column + 10) * (row + 20),
                        x: rowX,
                        y: tagSelectorHeight + row * (normalSize + spacing)
                      })
                    }
                    rowX += normalSize + spacing
                    column += 1
                    if (column === numberOfCol || (item.isBigger && column + 1 >= numberOfCol) || (item.isRect && column + 2 >= numberOfCol)) {
                        while (column !== numberOfCol) {
                            if (!grid[`${row};${column}`]) {
                                this.holes.push({
                                    key: (column + 10) * (row + 20),
                                    x: rowX,
                                    y: tagSelectorHeight + row * (normalSize + spacing)
                                })
                            }
                            column += 1
                            rowX += normalSize + spacing
                        }
                        rowX = spacing / 2
                        row += 1
                        column = 0
                    }
                }
                let x = rowX
                let y = tagSelectorHeight + row * (normalSize + spacing)
                if (item.isBigger) {
                    grid[`${row + 1};${column}`] = true
                    grid[`${row + 1};${column + 1}`] = true
                } else if (item.isRect) {
                    grid[`${row + 1};${column}`] = true
                    grid[`${row + 1};${column + 1}`] = true
                    grid[`${row + 1};${column + 2}`] = true
                }
                column += item.isRect ? 3 : item.isBigger ? 2 : 1
                rowX += item.size + spacing
                height = y + biggerSize + spacing + startY
                n += 1
                return {
                    key: item.id,
                    url: item.url,
                    x,
                    y,
                    n,
                    size: item.size,
                    isRect: item.isRect ? biggerSize + spacing : false,
                    isBigger: item.isBigger,
                    name: item.name,
                    video: item.video
                }
            })
            if (this.holes.length > 0) {
                const temp = []
                const tempN = {}
                this.holes.forEach((hole, index) => {
                    const i = index % holes.length
                    if (index < holes.length) {
                        tempN[holes[i]._id] = ++n
                    }
                    temp.push({
                        key: index < holes.length ? `${holes[i]._id}_placeholder` : `${holes[i]._id}_${index}`,
                        n: tempN[holes[i]._id],
                        url: holes[i].url,
                        x: hole.x,
                        y: hole.y,
                        size: normalSize,
                        isRect: false,
                        name: holes[i].name,
                        hold: true
                    })
                })
                if (temp.length >= 6 && item.length >= 11) {
                    const [a, b, c, d, e, f, g, h, i, j, k, ...itemRest] = item
                    const [l, m, o, p, q, r, ...last] = temp
                    item = [a, b, c, d, e, f, g, h, i, j, k, l, m, o, p, q, r, ...itemRest, ...last]
                } else {
                    item.unshift(...temp)
                }
            }
        } else {
            classN.push("open")
            let x = 0
            height = openHeight
            width = window.innerWidth
            let n = -1
            item = items.map(item => {
                let curX = x
                x += width + 100
                n++
                return {
                    key: item.id,
                    url: item.url,
                    x: curX,
                    y: 0,
                    n,
                    size: width,
                    name: item.name,
                    video: item.video
                }
            })
            if (this.holes.length > 0) {
                for (let i = 0; i < this.holes.length && i < holes.length; i++) {
                    const hole = holes[i]
                    let curX = x
                    x += width + 100
                    n++
                    item.push({
                        key: `${holes[i]._id}_placeholder`,
                        url: hole.url,
                        x: curX,
                        y: 0,
                        n,
                        size: width,
                        name: hole.name
                    })
                }
            }
        }
        item = item.map(i => {
            const {x, y, url, size, key, name , isRect, video, isBigger, n} = i
            const { open, closing } = this.state
            return <Item
                open={open}
                closing={closing}
                activeN={activeN}
                height={height}
                video={video}
                onOpen={this.onOpen}
                isRect={isRect}
                isBigger={isBigger}
                key={key}
                n={n}
                url={url}
                x={x + (open ? 0 : startX)}
                y={y + (open ? 0 : startY)}
                size={size}
                name={name}
                translateX={translateX}
            />
        })
        return (
            <>
                {open && (
                    <div className="background" />
                )}
                <div ref={this.layout} no-touch="true" className={classN.join(' ')}  style={{height: open ? openHeight : height, width, transform: `translate3d(${open ? translateX * -1 : 0}px, 0, 0)`}}>
                    {item}
                </div>
                {open && (
                    <>
                        <div className="close_button" onClick={this.onClose} />
                        <div className="arrow previous" onClick={this.previous} />
                        <div className="arrow next" onClick={this.next} />
                    </>
                )}
            </>
        )
    }
}

Layout.defaultProps = {
    startX: 25,
    startY: 25,
    maxWidth: 800
}

export default Layout
